import React from 'react';

import Spacing from './Spacing';

export default function FormSpacing() {
  return <Spacing y={2} x={1} />;
}
